import { cn } from '@creator/ui/utils/ui';
import { getCurrentPathAndSearch } from '@src/utils/url-utils/url-utils';
import type { FC, PropsWithChildren } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Icon from '../Icon/Icon';

export interface ResponseFullScreenButtonProps {
    className?: string;
    postId: string;
}

const ResponseFullScreenButton: FC<PropsWithChildren<ResponseFullScreenButtonProps>> = props => {
    const { className = '', postId } = props;

    const navigate = useNavigate();
    const { t } = useTranslation();

    function getBaseClassname(): string {
        return cn('cursor-pointer text-[20px] py-0.5 px-4 flex items-center justify-center bg-linear-to-t to-[#6FE5ED] from-[#18B5BF] rounded-full text-gray-50', className);
    }

    const onClick = useCallback(
        e => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/bbs/response/${postId}?backLinkUrl=${encodeURIComponent(getCurrentPathAndSearch())}&backLinkLabel=${t('backToPost')}`);
        },
        [postId, navigate, t]
    );

    return (
        <div onClick={onClick} className={getBaseClassname()}>
            <Icon name="response2" />
        </div>
    );
};

export default ResponseFullScreenButton;
